import React, { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import NextLink, { LinkProps } from 'next/link';



interface IMDLinkProps extends LinkProps {
    children: React.ReactNode;
    title?: string;
}

const MDLink: FC<IMDLinkProps> = (props: IMDLinkProps) => {
    const theme = useTheme();
    const regEx = /^http/;
    const isRemoteLink = regEx.test(props.href as string);

    return (
        isRemoteLink
            ? <Link color={'inherit'} href={props.href as string} title={props.title} target='_blank' rel='noopener noreferrer'>{props.children}</Link>
            : <NextLink href={props.href} locale={props.locale} passHref>
                <Link color={'inherit'}  title={props.title}>
                    {props.children}
                </Link>
            </NextLink>
    );
}

export default MDLink;